export const LOCAL_PACK_AVAILABLE_SERVICES_KEY = 'localpack_search_services';
export const LOCAL_PACK_TRIAl_AVAILABLE_SERVICES_KEY = 'localpack_trial_search_services';
export const LOCAL_PACK_BRANDS_KEY = 'localpack_brands';
export const LOCAL_PACK_RULE_KEY = 'localpack_rule';
export const LOCAL_PACK_RULES_KEY = 'localpack_brands';
